module.exports = __webpack_public_path__ + "static/media/cosplay9.8fb1b8c3.jpg";